const COMPARE_KEY = 'compare_products';
const MAX_COMPARE = 4;

function getCompareList() {
  return JSON.parse(localStorage.getItem(COMPARE_KEY) || '[]');
}

function saveCompareList(list) {
  localStorage.setItem(COMPARE_KEY, JSON.stringify(list));
}

function escapeHtml(str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function updateCompareBar() {
  const list = getCompareList();
  const count = list.length;

  // Floating pill
  const fab = document.getElementById('compare-fab');
  const fabCount = document.getElementById('compare-fab-count');
  if (fab) fab.classList.toggle('compare-fab--hidden', count === 0);
  if (fabCount) fabCount.textContent = count;

  // Drawer count
  const drawerCount = document.getElementById('compare-drawer-count');
  if (drawerCount) drawerCount.textContent = count;

  // Drawer slots
  const slotsEl = document.getElementById('compare-drawer-slots');
  if (slotsEl) {
    const remaining = MAX_COMPARE - count;
    const emptyText = remaining > 0
      ? `Add up to ${remaining} more ${remaining === 1 ? 'item' : 'items'} to compare`
      : '';
    const parts = [];

    list.forEach(p => {
      const id = escapeHtml(p.id);
      const title = escapeHtml(p.title);
      const img = escapeHtml(p.image);
      parts.push(
        '<div class="compare-drawer__slot">' +
          '<button type="button" class="compare-drawer__slot-remove" onclick="removeCompareById(\'' + id + '\')" aria-label="Remove">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
          '<img src="' + img + '" alt="' + title + '">' +
          '<div class="compare-drawer__slot-title">' + title + '</div>' +
        '</div>'
      );
    });

    for (let i = count; i < MAX_COMPARE; i++) {
      parts.push('<div class="compare-drawer__slot compare-drawer__slot--empty">' + emptyText + '</div>');
    }

    slotsEl.innerHTML = parts.join('');
  }

  // Auto-close the drawer if nothing left to compare
  if (count === 0) closeCompareDrawer();
}

function openCompareDrawer() {
  const drawer = document.getElementById('compare-drawer');
  if (!drawer) return;
  drawer.classList.remove('compare-drawer--hidden');
  document.body.style.overflow = 'hidden';
}

function closeCompareDrawer() {
  const drawer = document.getElementById('compare-drawer');
  if (!drawer) return;
  drawer.classList.add('compare-drawer--hidden');
  document.body.style.overflow = '';
}

// Pull all data-compare-* attributes off the checkbox into an object
function getCompareData(cb) {
  const data = {};
  for (const key in cb.dataset) {
    if (key.startsWith('compare')) {
      const field = key.slice(7).charAt(0).toLowerCase() + key.slice(8);
      data[field] = cb.dataset[key];
    }
  }
  return data;
}

function toggleCompare(cb) {
  const data = getCompareData(cb);
  let list = getCompareList();
  const index = list.findIndex(p => p.id === data.id);

  if (index > -1) {
    list.splice(index, 1);
  } else {
    if (list.length >= MAX_COMPARE) {
      alert(`You can compare up to ${MAX_COMPARE} products`);
      cb.checked = false;
      return;
    }
    list.push(data);
  }

  saveCompareList(list);
  updateCompareBar();

  // Sync all checkboxes for this product
  document.querySelectorAll(`[data-compare-id="${data.id}"]`).forEach(other => {
    other.checked = index === -1;
  });
}

// Called from the × button on each drawer slot
function removeCompareById(id) {
  let list = getCompareList();
  const before = list.length;
  list = list.filter(p => String(p.id) !== String(id));
  if (list.length === before) return;
  saveCompareList(list);
  document.querySelectorAll(`[data-compare-id="${id}"]`).forEach(cb => { cb.checked = false; });
  updateCompareBar();
}

function clearCompare() {
  saveCompareList([]);
  document.querySelectorAll('[data-compare-id]').forEach(cb => { cb.checked = false; });
  updateCompareBar();
}

function goCompare() {
  const list = getCompareList();
  if (list.length < 2) { alert('Please select at least 2 products to compare'); return; }
  window.location.href = `/pages/comparison`;
}

function initCompareCheckboxes() {
  const list = getCompareList();
  const ids = list.map(p => p.id);
  document.querySelectorAll('[data-compare-id]').forEach(cb => {
    cb.checked = ids.includes(cb.dataset.compareId);
    cb.addEventListener('change', () => toggleCompare(cb));
  });
  updateCompareBar();
}

// Esc closes the drawer
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeCompareDrawer();
});

document.addEventListener('DOMContentLoaded', initCompareCheckboxes);
// Re-init after AJAX / infinite-scroll section loads
document.addEventListener('shopify:section:load', initCompareCheckboxes);
